<template>
  <div id="comp_calender" :class="{ 'h5-comp-calender': isH5 }">
    <Calendar
      :key="key"
      v-on:choseDay="clickDay"
      v-on:changeMonth="changeMonth"
      :markDateMore="markDate"
    ></Calendar>
    <!-- 回到今天 -->
    <button v-if="showJumpTodayBtn" @click="jumpToday" class="jump-today-btn">
      今
    </button>
    <div class="tips">
      <button class="show-all-btn" @click="showAllData">全部课程</button>
    </div>
  </div>
</template>
<script>
import { isH5 } from "@saas/components";
import Calendar from "vue-calendar-component";
import moment from "moment";

export default {
  props: {
    markDate: {
      type: Array,
      default: () => {
        return [];
      },
    },
    showJumpTodayBtn: {
      type: Boolean,
      default: false,
    },
  },
  name: "MyCalendar",
  data() {
    return {
      moment,
      key: "",
      isH5: isH5(),
    };
  },

  methods: {
    showAllData() {
      this.key = new Date().getTime();
      this.$emit("showAllData");
    },
    clickDay(data) {
      this.$emit("clickDay", moment(new Date(data)).format("YYYY-MM-DD"));
    },
    changeMonth(data) {
      this.$emit("changeMonth", moment(new Date(data)).format("YYYY-MM"));
      console.log(data); //左右点击切换月份
    },
    jumpToday() {
      this.key = new Date().getTime();
      this.$emit("jumpToday", moment(new Date()).format("YYYY-MM-DD"));
    },
  },
  mounted() {},
  components: {
    Calendar,
  },
};
</script>
<style lang="scss">
#comp_calender {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 14px 14px 30px;
  width: 330px;
  background: #ffffff;
  border-radius: 24px;
  position: relative;
  .jump-today-btn {
    width: 24px;
    height: 24px;
    background: #e2fff7;
    border-radius: 20px;
    font-weight: 500;
    font-size: 14px;
    color: #1d2129;
    line-height: 22px;
    position: absolute;
    left: calc(50% + 48px);
    top: 22px;
    cursor: pointer;
    z-index: 6;
  }
  .wh_jiantou1,
  .wh_jiantou2 {
    width: 6px !important;
    height: 6px !important;
    border-color: #4e5969 !important;
  }
  .show-all-btn {
    width: 252px;
    height: 33px;
    background: #ffffff;
    border: 1px solid rgba($color: $saas-border-color, $alpha: 0.4);
    font-weight: 500;
    font-size: 14px;
    color: #1d2129;
    line-height: 20px;
    border-radius: 10px;
  }
  .wh_container {
    position: relative;
    z-index: 2;
    margin: 0;
  }
  .wh_content_li {
    font-weight: 500;
    font-size: 14px;
    color: #1d2129;
  }
  .wh_top_changge li {
    height: 40px;
  }
  .wh_top_changge {
    padding: 0 !important;
    border-bottom: 1px solid #e5e6eb;
    margin-bottom: 16px;
  }
  .wh_content {
    padding: 0 5% !important;
  }

  .wh_content_item {
    margin-bottom: 4px;
    color: $primary-color;
  }
  .el-button--primary {
    padding: 8px 16px;
  }
  .mark1:after {
    position: absolute;
    bottom: 10px;
    width: 4px;
    height: 4px;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    content: "";
    border-radius: 50%;
  }
  .wh_item_date:hover {
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    color: #fff;
    border-radius: 50%;
  }
  .wh_top_changge {
    padding: 0 5%;
  }
  .wh_top_changge li {
    color: #999;
  }
  .wh_jiantou1,
  .wh_jiantou2 {
    border-color: #999;
    width: 10px;
    height: 10px;
  }
  .wh_content_all {
    background-color: transparent;
    .wh_chose_day,
    .wh_chose_day:hover {
      color: #fff;
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      border-radius: 50%;
    }

    .wh_content {
      justify-content: space-around;
      padding: 0 8%;
    }
    .wh_content_li {
      color: $primary-color;
      font-weight: 500;
    }
  }
  .wh_isToday {
    color: #1d2129;
    background: #e2fff7;
    border-radius: 50%;
  }
  .calender_title {
    height: 38px;
    background: #456399;
    color: rgba(255, 255, 255, 0.5);
    text-align: center;
    line-height: 38px;
    font-size: 18px;
    position: relative;
    .study-plan {
      position: absolute;
      top: 0;
      left: 13px;
      cursor: pointer;
    }
    .timetable {
      cursor: pointer;
    }
    .title-selected {
      color: white;
    }
    .calender_now {
      position: absolute;
      top: 10px;
      right: 13px;
      font-size: 12px;
      color: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
      font-weight: 500;
      background-color: $avatar-color;
      height: 20px;
      line-height: 20px;
      width: 40px;
      border-radius: 3px;
      cursor: pointer;
    }
  }
  .wh_item_date,
  .wh_top_tag {
    width: 24px;
    height: 24px;
  }
  .calender_week {
    display: flex;
    color: #333;
    font-weight: 600;
    padding: 20px 15px;
    background: white;
    font-size: 14px;
  }
  .calender_info {
    padding-bottom: 12px;
    background: white;
    // border-top: 1px solid #e8eaed;
    border-radius: 0 0 4px 4px;
    position: relative;
    .empty-content {
      min-height: 230px;
      img {
        width: 42px;
      }
      .empty-info {
        font-size: 14px;
      }
    }
    .classtext {
      padding: 15px 15px 0px 15px;
      border-top: 1px solid #e8eaed;
      font-size: 14px;
      .sub-time {
        color: $chiral-free-color;
      }
      .sub-title {
        font-size: 16px;
        font-weight: 500;
        color: #222222;
      }
      div {
        margin-bottom: 22px;
      }
    }
    .noclass_img {
      text-align: center;
    }
    .warning {
      text-align: center;
      span {
        color: #809bc5;
      }
    }
  }
}

// h5适配
#comp_calender.h5-comp-calender {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.2rem 0.4rem 0.4rem;
  width: 9.36rem;
  background: #ffffff;
  border-radius: 0.32rem;
}
</style>
